import React, { memo } from 'react'
import { Grid2, useMediaQuery, useTheme } from '@mui/material'

import PageTitle from '../shared/pageTitle/PageTitle'
import MembershipProfile from './MembershipProfile'
import NextLevelInfo from './NextLevelInfo'
import MembershipFeatures from './MembershipFeatures'
import Perks from './Perks'

const Membership = ({
  t,
  mainProfile: { tiers, userTier },
  stakingProfile: { stakedQBX },
  tokenProfile: { symbol },
  onOpenPerk
}) => {
  const pageTitle = t('membership.membership-status')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const perksContent = () => (
    <Grid2 size={{ xs: 12 }}>
      <Perks t={t} userTier={userTier} onOpenPerk={onOpenPerk} />
    </Grid2>
  )
  return (
    <>
      <PageTitle title={pageTitle} />
      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, md: 4 }}>
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12 }}>
              <MembershipProfile
                t={t}
                userTier={userTier}
                stakedQBX={stakedQBX}
              />
            </Grid2>
            {!isMobile && perksContent()}
          </Grid2>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 8 }}>
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12 }}>
              <NextLevelInfo
                t={t}
                totalFiatValue={userTier.totalFiatValue}
                tiers={tiers}
                isMobile={isMobile}
              />
            </Grid2>
            {isMobile && perksContent()}
            <MembershipFeatures
              t={t}
              tiers={tiers}
              currentTier={userTier.tier.id}
              symbol={symbol}
            />
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  )
}

export default memo(Membership)
